
const SustainabilityIconMapping: Record<string, any> = {
    "animal-welfare": 'sustainable-animal-welfare',
    "social-initiatives": 'sustainable-social-initiatives',
    "recyclable-design": 'sustainable-recyclable-design',
    "organic-materials": 'sustainable-organic-materials',
    "recycling": 'sustainable-recycling',
    "production": 'sustainable-production',
    "resource": 'sustainable-resource'
}

export const getSustainabilityIconName = (featureName: string): string | undefined => {
    return SustainabilityIconMapping[featureName];
}